import { fromJS, List, Record } from 'immutable';
import { v4 } from 'uuid';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../../utils/helpers/model.helper';
import { TaxRate } from './tax-rate.model';

export const TAX_SCHEMA = Object.freeze({
  ID: '',
  NAME: '',
  INCLUSIVE: false,
  AUTO_APPLY: true,
  RATES: List<TaxRate>([]),
  ACCUMULATIVE_OF: List<string>([]),
});
const RECORD = generateSchema(TAX_SCHEMA);
const KEYS: any = generateKeys(TAX_SCHEMA);

export class Tax extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    if (!props.get(KEYS.ID)) {
      props = props.set(KEYS.ID, v4());
    }

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.RATES,
        value: props.get(KEYS.RATES)
          ? List(this.rates).map((params) => new TaxRate(params))
          : List<TaxRate>([]),
      },
      {
        key: KEYS.ACCUMULATIVE_OF,
        value: props.get(KEYS.ACCUMULATIVE_OF)
          ? List(this.accumulativeOf).map((value) => value.toString())
          : List<string>([]),
      },
    ]);

    return selfModel as Tax;
  }

  get id(): string {
    return this.get(KEYS.ID);
  }

  get name(): string {
    return this.get(KEYS.NAME);
  }

  get rates(): List<TaxRate> {
    return this.get(KEYS.RATES);
  }

  get firstRate(): number {
    const taxRate: TaxRate = this.rates.get(0);

    return taxRate ? taxRate.value : 0;
  }

  get inclusive(): boolean {
    return this.get(KEYS.INCLUSIVE);
  }

  get autoApply(): boolean {
    return this.get(KEYS.AUTO_APPLY);
  }

  get accumulativeOf(): List<string> {
    return this.get(KEYS.ACCUMULATIVE_OF);
  }
}
